import { BaseService } from './base.service';
import type {
  CreateLinearIssueInput,
  SupportTicketAssignee,
  SupportTicketDetailDto,
  SupportTicketFilters,
  SupportTicketList,
} from '@/types/support-ticket';

export class SupportTicketService extends BaseService {
  constructor() {
    super('/support-tickets');
  }

  list(filters: SupportTicketFilters = {}): Promise<SupportTicketList> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.set(key, String(value));
      }
    });
    const qs = params.toString();
    return this.get<SupportTicketList>(qs ? `?${qs}` : '');
  }

  getAssignees(): Promise<SupportTicketAssignee[]> {
    return this.get<SupportTicketAssignee[]>('/assignees');
  }

  getTicket(id: string): Promise<SupportTicketDetailDto> {
    return this.get<SupportTicketDetailDto>(`/${id}`);
  }

  assign(id: string, assigneeUserId?: string): Promise<SupportTicketDetailDto> {
    return this.post<SupportTicketDetailDto>(
      `/${id}/assign`,
      assigneeUserId ? { assigneeUserId } : {},
    );
  }

  close(id: string, resolutionNote: string): Promise<SupportTicketDetailDto> {
    return this.post<SupportTicketDetailDto>(`/${id}/close`, { resolutionNote });
  }

  createLinearIssue(
    id: string,
    input: CreateLinearIssueInput,
  ): Promise<SupportTicketDetailDto> {
    return this.post<SupportTicketDetailDto>(`/${id}/linear-issue`, input);
  }

  reply(
    id: string,
    message: string,
    files: File[] = [],
  ): Promise<SupportTicketDetailDto> {
    if (files.length === 0) {
      return this.post<SupportTicketDetailDto>(`/${id}/reply`, { message });
    }
    const formData = new FormData();
    formData.append('message', message);
    files.forEach((file) => formData.append('files', file));
    return this.post<SupportTicketDetailDto>(`/${id}/reply`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export const supportTicketService = new SupportTicketService();
